<template>
  <div
    v-if="!items || !items.nome || (items.subCategorias || []).length"
    @click="itemClicked"
  >
    <dropdown class="btn_menu" :trigger="'hover'">
      <template slot="btn">
        {{ !items || !items.nome ? "Mais" : items.nome }}
        <span class="d-none">{{ !items ? "0" : items.id }}</span>
      </template>
      <template slot="body">
        <div
          v-for="(subMenu, indexSubMenu) in (!items
            ? []
            : items.subCategorias) || items"
          :key="indexSubMenu"
        >
          <dropdown
            :trigger="'hover'"
            :role="'sublist'"
            :align="'right'"
            v-if="(subMenu.subCategorias || []).length > 0"
          >
            <template slot="btn">
              {{ subMenu.nome }}<span class="d-none">{{ subMenu.id }}</span>
            </template>
            <template slot="body">
              <div
                v-for="(subSubMenu, indexSubSubMenu) in subMenu.subCategorias"
                :key="indexSubSubMenu"
              >
                <dropdown
                  :trigger="'hover'"
                  :role="'subsublist'"
                  :align="'right'"
                  v-if="(subSubMenu.subCategorias || []).length > 0"
                >
                  <template slot="btn">
                    {{ subSubMenu.nome
                    }}<span class="d-none">{{ subSubMenu.id }}</span>
                  </template>
                  <template slot="body">
                    <button
                      class="btn btn_color_system py-1 px-0 w-100 text-left"
                      v-for="(subSubSubMenu,
                      indexSubSubSubMenu) in subSubMenu.subCategorias"
                      :key="indexSubSubSubMenu"
                    >
                      {{ subSubSubMenu.nome
                      }}<span class="d-none">{{ subSubSubMenu.id }}</span>
                    </button>
                  </template>
                </dropdown>
                <button
                  v-else
                  class="btn btn_color_system py-1 px-0 w-100 text-left"
                >
                  {{ subSubMenu.nome
                  }}<span class="d-none">{{ subSubMenu.id }}</span>
                </button>
              </div>
            </template>
          </dropdown>
          <button v-else class="btn btn_color_system py-1 px-0 w-100 text-left">
            {{ subMenu.nome }}<span class="d-none">{{ subMenu.id }}</span>
          </button>
        </div>
      </template>
    </dropdown>
  </div>
  <button v-else class="btn btn_color_system" @click="itemClicked">
    {{ items.nome }}<span class="d-none">{{ items.id }}</span>
  </button>
</template>

<script>
import Dropdown from "bp-vuejs-dropdown";
export default {
  name: "Dropdown1",
  components: { Dropdown },
  props: ["onClick", "items"],
  data() {
    return {};
  },
  mounted() {},
  methods: {
    itemClicked(evt) {
      console.log(evt);
      const n = evt.target.firstElementChild.innerText;
      const categoriaId = n > 0 ? n : null;
      this.onClick(categoriaId);
    },
  },
};
</script>

<style>
.bp-dropdown__btn {
  border: none;
}
.bp-dropdown__btn--active {
  background-color: rgba(0, 0, 0, 0.1);
}
.bp-dropdown__body {
  background-color: var(--cor-principal);
}
.bp-dropdown__body .bp-dropdown__body {
  margin: -10px 7px;
}
.bp-dropdown__body .bp-dropdown__body .bp-dropdown__body {
  margin: -12px 7px;
}
.bp-dropdown__body button {
  line-height: 1.65rem;
}
.bp-dropdown.bp-dropdown--sub {
  padding: 6px 0;
  cursor: pointer;
}
</style>

<style scoped lang="scss">
.btn_menu {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent !important;
  outline: none !important;
  box-shadow: none !important;
  font-size: small;
}
.btn {
  box-shadow: none !important;
}
.menu {
  button {
    color: var(--cor-texto) !important;
  }
}
@media screen and (min-width: 992px) {
  .btn_menu {
    font-size: initial;
  }
  .anchor::after {
    display: inline-block;
    width: 0;
    height: 0;
    margin-left: 0.5em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.28em solid transparent;
    border-bottom: 0;
    border-left: 0.28em solid transparent;
  }
  .menu {
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 0.25rem;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: 1rem;
    list-style: none;
    margin: 0.125rem 0 0;
    padding: 0.5rem 0;
    position: absolute;
    text-align: left;
    color: #212529 !important;
    button {
      color: #212529 !important;
    }
  }
}
</style>
